<template>
  <input-number-with-popover 
    v-model="number"
    :min="min"
    controls-position="both"
    :max="max" 
    :data-tracking='dataTracking'
    size="large"
    :label="`${name} ${desc} ${label} Select the number of plans`"                            
    :disabled="disabled"
    @change="updateGlobalBundleLicense"
  />
</template>
<script>
import { DEFAULT_MAX_HOST, DEFAULT_MIN_HOST, planTypes } from '@/common/constants';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import { PBX_REGIONS } from '@/plans/ZOOM_PHONE/helper/constants';
import get from 'lodash/get';
import { mapMutations } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  name: 'GlobalOnlyNumber',
  components: {
    InputNumberWithPopover
  },
  data() {
    return {
      number: 1
    }
  },
  props: {
    min: {
      type: Number,
      default: DEFAULT_MIN_HOST
    },
    max: {
      type: Number,
      default: DEFAULT_MAX_HOST
    },
    dataTracking: {
      type: Object,
      required: false,
    },
    name: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'planMapFlat', 'pbxBaseInfo']),
    selectGlobalBundle() {
      return this.getSelectedPlans.find(item => item.type === planTypes.ZOOM_ONE_BUNDLE && item.region === PBX_REGIONS.GLOBAL);
    },
    defaultGlobalBundle() {
      return this.planMapFlat.find(item => (
        item.type === planTypes.ZOOM_ONE_BUNDLE && 
        item.region === PBX_REGIONS.GLOBAL && 
        item.billing_cycle === this.pbxBaseInfo.billingCycle
      ))
    },
    selectedNumber() {
      return get(this.selectGlobalBundle || {}, 'cartInfo.selected_number', 0);
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    updateGlobalBundleLicense(num) {
      const targetPlan = this.selectGlobalBundle || this.defaultGlobalBundle;
      if (!targetPlan) return;
      this.updateSelectPlan({
        ...targetPlan,
        cartInfo: {
          ...targetPlan.cartInfo,
          selected_number: num
        }
      })
      this.$emit('change');
    }
  },
  watch: {
    selectedNumber: {
      immediate: true,
      handler(v) {
        this.number = v
      }
    }
  }
}
</script>
